import React from 'react';
import { useParams } from 'react-router-dom';
import '../BlogDetailPage/Styles.css';
import ContactSection from '../ContactSection/Index';
import useTitle from '../../useTitle';
import { PortableText } from '@portabletext/react';

import { useBlog } from '../../context/BlogContext';
import { urlFor } from '../../sanityProject/urlFor';

const BlogDetail = () => {
  const { slug } = useParams();
  const { posts } = useBlog();

  const post = posts?.find(p => p.slug?.current === slug);

  useTitle(post?.headTitle || post?.title || "Blog Detail");

  if (!post) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <div className='blogDetailSection'>
        <div className='blogItem'>

          {/* HEADER IMAGE */}
          <div className='headerImageContainerBlog'>
            {post.headerImage && (
              <img
                src={urlFor(post.headerImage).url()}
                className='headerofBlogPost'
                alt={post.title}
              />
            )}
          </div>

          {/* NAVIGATION */}
          <div className='navSectionBlog'>
            <a href='/'>Home</a>
            <p>{'>'}</p>
            <a href='/blog'>Blog</a>
            <p>{'>'}</p>
            <a href={`/blog/${slug}`}>
              {post.title}
            </a>
          </div>

          {/* TITLE */}
          <div className='titleBlogDetailSection'>
            <h1 className='titleOfBlog'>
              {post.headTitle || post.title}
            </h1>
          </div>

          {/* AUTHOR + DATE */}
          <div className='authorAndDateSection'>
            <p className='dateBlogDetailPost'>
              {post.date
                ? new Date(post.date).toLocaleDateString('nl-BE')
                : ''}
            </p>

            <div className='authorOfBlogPost'>
              {post.author?.image && (
                <img
                  src={urlFor(post.author.image).url()}
                  className='authorImagePhoto'
                  alt={post.author?.name}
                />
              )}

              <p className='authorName'>
                {post.author?.name || ''}
              </p>
            </div>
          </div>

          {/* SUMMARY */}
          <div className='summarySection'>
            <PortableText value={post.summary} />
          </div>

          {/* SECTION 1 */}
          <div className='blogSection'>
            <div className='subtitle'>
              <h2>{post.subtitle1}</h2>
            </div>

            <div className='blogText'>
              <PortableText value={post.text1} />
            </div>

            {post.picture1 && (
              <div className='photoOfBlog'>
                <img
                  src={urlFor(post.picture1).url()}
                  className='photoOfBlogSection'
                  alt=''
                />
              </div>
            )}
          </div>

          {/* SECTION 2 */}
          <div className='blogSection'>
            <div className='subtitle'>
              <h2>{post.subtitle2}</h2>
            </div>

            <div className='blogText'>
               <PortableText value={post.text2} />
            </div>

            {post.picture2 && (
              <div className='photoOfBlog'>
                <img
                  src={urlFor(post.picture2).url()}
                  className='photoOfBlogSection'
                  alt=''
                />
              </div>
            )}
          </div>

          {/* SECTION 3 */}
          <div className='blogSection'>
            <div className='subtitle'>
              <h2>{post.subtitle3}</h2>
            </div>

            <div className='blogText'>
               <PortableText value={post.text3} />
            </div>

            {post.picture3 && (
              <div className='photoOfBlog'>
                <img
                  src={urlFor(post.picture3).url()}
                  className='photoOfBlogSection'
                  alt=''
                />
              </div>
            )}
          </div>

          {/* DIVIDER */}
          <div className='dividerBlog'></div>

          {/* AUTHOR FOOTER */}
          <div className='authorOfBlog'>
            <div className='authorProfilePicBlog'>
              {post.author?.image && (
                <img
                  src={urlFor(post.author.image).url()}
                  className='authorImagePhoto'
                  alt={post.author?.name}
                />
              )}
            </div>

            <div className='authorNameBlog'>
              <p>Author: {post.author?.name || ''}</p>
            </div>
          </div>

        </div>
      </div>

      <ContactSection />
    </>
  );
};

export default BlogDetail;